<template>
  <el-dialog :visible="showModal" width="80%" :show-close="false" :modal-append-to-body="false" @close="$emit('close')">
    <div class="header">
      <div class="header-title">
        {{ name }}
      </div>
      <div @click="showModal = false;" class="header-close"><i class="el-icon-close"></i></div>
    </div>
    <div class="main" v-if="showModal">
      <iframe :src="url"    width="100%" height="100%" autoplay></iframe>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ModalLiveVideo",
  data() {
    return {
      showModal: false,
      name: "",
      url: ""
    };
  },
  methods: {
    open({name,url}) {
      this.name = name;
      this.url = url;
      this.showModal = true;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../style/_parameter.scss";

.header {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: -30px;
  box-sizing: border-box;
  padding: 0 30px;

  .header-title {
    font-size: 34px;
    color: rgb(181, 228, 255);
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .header-video-btn{
    font-size: 30px;
    color: #fff;
  }


  .header-close{
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: $red;
    border-radius: 100%;
    i{
      font-size: 40px;
    }
    cursor: pointer;
    &:hover{
      opacity: .8;
    }
  }
}

.main {
  width: 100%;
  height: 1600px;
  margin-top: 20px;
}
</style>
